module.exports = __webpack_public_path__ + "img/PF.cd51dc27.svg";